// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-email-send-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.verify-email-send-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 450px;
  text-align: center;
}

.logo-container {
  margin-bottom: 30px;
}

.logo {
  height: 60px;
  width: auto;
}

.verify-email-send-card h1 {
  color: #333;
  margin-bottom: 15px;
  font-size: 28px;
  font-weight: 600;
}

.description {
  color: #666;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 25px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e1e1e1;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
}

.error-message,
.modal-custom-content .error-message {
  background-color: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #fcc;
  font-size: 14px;
}

.success-message {
  background-color: #efe;
  color: #3c3;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #cfc;
  font-size: 14px;
}

.verify-email-send-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.back-to-login {
  margin: 0;
}

.back-to-login a {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.back-to-login a:hover {
  color: #0056b3;
  text-decoration: underline;
}

@media screen and (max-width: 480px) {
  .verify-email-send-container {
    padding: 10px;
  }

  .verify-email-send-card {
    padding: 30px 20px;
  }

  .verify-email-send-card h1 {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/VerifyEmailSend/VerifyEmailSend.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".verify-email-send-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n  padding: 20px;\n}\n\n.verify-email-send-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  width: 100%;\n  max-width: 450px;\n  text-align: center;\n}\n\n.logo-container {\n  margin-bottom: 30px;\n}\n\n.logo {\n  height: 60px;\n  width: auto;\n}\n\n.verify-email-send-card h1 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.description {\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.form-group {\n  margin-bottom: 25px;\n  text-align: left;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #333;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e1e1e1;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.error-message,\n.modal-custom-content .error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border: 1px solid #fcc;\n  font-size: 14px;\n}\n\n.success-message {\n  background-color: #efe;\n  color: #3c3;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border: 1px solid #cfc;\n  font-size: 14px;\n}\n\n.verify-email-send-footer {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.back-to-login {\n  margin: 0;\n}\n\n.back-to-login a {\n  color: #007bff;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.back-to-login a:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n@media screen and (max-width: 480px) {\n  .verify-email-send-container {\n    padding: 10px;\n  }\n\n  .verify-email-send-card {\n    padding: 30px 20px;\n  }\n\n  .verify-email-send-card h1 {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
